export default __webpack_public_path__ + "static/scams-hub-jan-mar-2024-f0b38975aa8a2a794190bc720049afd2.webp";